import { DateTime } from "luxon";
import { getUsMarketOpenness } from "./getUsMarketOpenness";

export const isUsMarketOpen = (dateTime: DateTime) => {
  return getUsMarketOpenness(dateTime) === "Open";
};
